<template>
  <input type="hidden" :value="value" />
</template>

<script>
// TODO: Нужно ли рендерить это поле?

export default {
  name: "HiddenField",
  props: ["value"]
};
</script>

<style scoped></style>
